import React, { useState, useEffect, useMemo } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Link } from "react-router-dom";
import DataTable, { createTheme } from "react-data-table-component";
import { useAtom } from "jotai";
import classes from "../../../assets/styles/Contact.module.css";
import { CONTACT_US } from "../../../utils/constants/apiUrl";
import { get, post, deleteRecord } from "../../../server";
import showToast from "../../../helpers/showToast";
import { loggedInUser } from "../../../utils/store";
import Loader from "../../../components/Loader";
import ConfirmationModal from "../../../components/Modals/ConfirmationModal";
import ContactUsStatusModal from "../../../components/Modals/ContactUsStatusModal";
import FormInput from "../../../components/Forms/FormInput";
import searchIcon from "../../../assets/images/global_icons/searchicon.svg";

const AllContactUs = () => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [loading, setLoading] = useState(false);
  const [contactUs, setContactUs] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [selectedStatusModal, setSelectedStatusModal] = useState({});
  const [filterText, setFilterText] = useState("");

  const handleFilter = (e) => {
    setFilterText(e.target.value);
  };

  const loadContactUs = async () => {
    setLoading(true);
    let { status, message, data } = await get(
      CONTACT_US,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      if (data.length > 0) {
        setContactUs(data);
      }
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadContactUs();
  }, []);

  const filteredItems = useMemo(() => {
    const filtered = contactUs.filter(
      (item) =>
        `${item.first_name || ""} ${item.last_name || ""}`
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        `${item.email || ""}`
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        `${item.subject || ""}`.toLowerCase().includes(filterText.toLowerCase())
    );

    return filtered;
  }, [filterText, contactUs]);

  createTheme(
    "solarized",
    {
      background: {
        default: "background: var(--secondary_color)",
      },
    },
    "dark"
  );

  const columns = [
    {
      name: "Name",
      width: "20%",
      cell: (row) => (
        <div className="profileWrapper">
          <p className="globalDetail">
            {row.first_name} {row.last_name}
          </p>
        </div>
      ),
    },
    {
      name: "Email",
      width: "20%",
      cell: (row) => (
        <a
          href={`mailto:${row.email}`}
          className={"globalDetail"}
          style={{ display: "block" }}
        >
          {row.email}
        </a>
      ),
    },
    {
      name: "Subject",
      cell: (row) => <div className={"globalDetail"}>{row.subject}</div>,
    },

    {
      name: "Status",
      cell: (row) => (
        <div className={"globalDetail"}>
          {row.status
            ? row.status === "in_progress"
              ? "In Progress"
              : row.status.toUpperCase()
            : "Pending"}
        </div>
      ),
    },
    {
      name: "Created At",
      //cell: (row) => <p className="globalDetail">{row.created_at}</p>,
      cell: (row) => {
        const creationDate = new Date(row.created_at);
        const formattedDate = creationDate.toLocaleString();
        return <p className="globalDetail">{formattedDate}</p>;
      },
    },
    {
      name: "Action",
      right: "true",
      cell: (row) => (
        <div className={classes.action}>
          <button
            className="btn customActionDropdown dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <BsThreeDotsVertical className={"globalVerticalThreeDots"} />
          </button>
          <ul className="customActionDropdownMenu dropdown-menu dropdown-menu-end ">
            <li>
              <Link className="dropdown-item" to={`AddEditContactUs/${row.id}`}>
                Show
              </Link>
            </li>
            <li>
              <Link
                className="dropdown-item"
                onClick={() => handleStatusChange(row)}
              >
                Change Status
              </Link>
            </li>

            <li>
              <Link
                className="dropdown-item"
                to="#"
                style={{ color: "#E35252" }}
                onClick={() => handleDelete(row.id)}
              >
                Delete
              </Link>
            </li>
          </ul>
        </div>
      ),
    },
  ];

  // Handle confirmation modal
  const handleShowConfirmationModal = () => setShowConfirmationModal(true);
  const handleCloseConfirmationModal = () => setShowConfirmationModal(false);

  // handle delete
  const handleDelete = (id) => {
    setDeleteId(id);
    handleShowConfirmationModal(true);
  };

  const handleConfirmDelete = async () => {
    handleCloseConfirmationModal(true);
    setLoading(true);
    let { status, message } = await deleteRecord(
      `${CONTACT_US}/${deleteId}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    showToast(status, message);

    if (status) {
      await loadContactUs();
      setLoading(false);
    }
    setLoading(false);
  };

  // Hanlde Status Change Modal
  const handleStatusChange = (row) => {
    setSelectedStatusModal(row);
    setStatusModal(true);
  };

  const handleStatusModalClose = () => {
    setSelectedStatusModal({});
    setStatusModal(false);
  };

  const handleStatusModalSubmit = async (data) => {
    handleStatusModalClose();
    setLoading(true);
    let { status, message } = await post(
      `${CONTACT_US}/changeStatus/${data.id}`,
      {
        status: data.status,
      },
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    showToast(status, message);
    if (status) {
      const allContacts = contactUs.map((contact) =>
        contact.id === data.id ? { ...contact, status: data.status } : contact
      );
      setContactUs(allContacts);
    }
    setLoading(false);
  };

  return (
    <>
      {!loading ? (
        <div>
          <div className="page_Header">
            {/* <Link to="AddEditAdminUser">
                <button className="primary_button align_right">Add</button>
              </Link> */}
            <div className="d-flex justify-content-between align-items-md-center align-items-initial flex-md-row flex-column gap-3 mb-3">
              <div className="heading">
                <h1 className="pageTitle">
                Contact Us Queries <span>({contactUs.length})</span>
              </h1>
              </div>

              {/* <FormInput
                icon={searchIcon}
                placeholder="Search..."
                value={filterText}
                handleChange={handleFilter}
              /> */}
              <div className="input-group" style={{ maxWidth: "250px", height: "45px" }}>
                  <span className="input-group-text bg-white border-end-0">
                    <img
                      src={searchIcon}
                      alt="search"
                      style={{ height: "16px" }}
                    />
                  </span>
                  <input
                    type="text"
                    className="form-control border-start-0"
                    placeholder="Search..."
                    value={filterText}
                    onChange={handleFilter}
                  />
                </div>
            </div>
          </div>

          <div className='default-list-table'>
            <DataTable
              columns={columns}
              data={filteredItems}
              pagination
              theme="solarized"
            />
          </div>

          <ConfirmationModal
            show={showConfirmationModal}
            handleCloseModal={handleCloseConfirmationModal}
            handleConfirmDelete={handleConfirmDelete}
          />

          <ContactUsStatusModal
            show={statusModal}
            data={selectedStatusModal}
            setSelectedData={setSelectedStatusModal}
            handleSaveShowModal={handleStatusModalSubmit}
            handleCloseModal={handleStatusModalClose}
          />
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default AllContactUs;
